import { useMutation, useQuery } from "react-query";

import { api } from "../../../../../../../api/profile-enrollment";


export const useDemography = () =>
    useQuery({
      queryKey: ["demography"],
      queryFn: () => api.getDemography(),
      // enabled: !!orgId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: false, // Disable automatic refetching
      refetchOnWindowFocus: false, 
    });
export const usePaygrades = (orgId) =>
    useQuery({
      queryKey: ["paygrades", orgId],
      queryFn: () => api.getPayGrades(orgId),
      enabled: !!orgId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: false, // Disable automatic refetching
      refetchOnWindowFocus: false, 
    });

export const useCountries = () =>
    useQuery({
      queryKey: ["countries"],
      queryFn: () => api.getCountries(),
    //   enabled: !!orgId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: false, // Disable automatic refetching
      refetchOnWindowFocus: false, 
    });

export const useDivisions = (orgId) =>
    useQuery({
      queryKey: ["divisions"],
      queryFn: () => api.getDivisions({ orgId }),
    //   enabled: !!orgId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: false, // Disable automatic refetching
      refetchOnWindowFocus: false, 
    });
export const useGender = (orgId) =>
    useQuery({
      queryKey: ["genders"],
      queryFn: () => api.getGender(orgId),
    //   enabled: !!orgId,
      staleTime: 10 * 60 * 1000, // 10 minutes
      refetchInterval: false, // Disable automatic refetching
      refetchOnWindowFocus: false, 
    });